APP.modal = (element, options) => {
	return true;
};
